import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { CrmBrandingSyncService } from './crm-branding-sync.service';

/**
 * After any successful write (POST/PUT/PATCH/DELETE) the user is clearly active, so
 * take the chance to re-read tenant branding — that is how a colour or logo change
 * made by another user reaches this session without a sign-out. The sync service
 * throttles it and ignores it outside the signed-in shell.
 */
export const crmBrandingActivityInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.method.toUpperCase() === 'GET' ||
    req.url.includes('/my-tenant/branding') ||
    // Login / refresh / logout: a branding read fired off the back of a logout
    // would land with no session and trip the 401 handling.
    req.url.includes('/auth/')
  ) {
    return next(req);
  }

  const brandingSyncService = inject(CrmBrandingSyncService);

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        brandingSyncService.refreshOnActivity();
      }
    }),
  );
};
